export const GAME_CONFIG = {
  SAVE_PROGRESS: false, // Persist progress in localStorage
  GRID_SIZE: 6, // Default grid size (4x4)
  TIME_LIMIT: 400, // Seconds per level
  FLIP_BACK_DELAY: 800, // ms before unmatched cards flip back
  POINTS_MATCH: 20, // Points gained per match
  POINTS_MISMATCH: -5, // Points lost per mismatch
  CARD_VALUES: ["🍎", "🚗", "🎮", "⚽", "🎲", "🎧", "🕹️", "🚀"],
};

export const STORAGE_KEY = "pairsMinigameProgress";

export const LEVEL_SETTINGS: Record<
  number,
  { gridSize: number; timeLimit: number; flipBackDelay: number }
> = {
  1: { gridSize: 4, timeLimit: 60, flipBackDelay: 550 }, // easy / tutorial
  2: { gridSize: 6, timeLimit: 150, flipBackDelay: 750 },
  3: { gridSize: 6, timeLimit: 220, flipBackDelay: 700 },
  4: { gridSize: 8, timeLimit: 200, flipBackDelay: 650 },
  5: { gridSize: 8, timeLimit: 160, flipBackDelay: 600 },
  6: { gridSize: 8, timeLimit: 140, flipBackDelay: 550 },
  7: { gridSize: 8, timeLimit: 120, flipBackDelay: 500 },
  8: { gridSize: 8, timeLimit: 100, flipBackDelay: 450 },
  9: { gridSize: 8, timeLimit: 90, flipBackDelay: 420 },
  10: { gridSize: 8, timeLimit: 80, flipBackDelay: 400 },
};
